<template>
  <div class="-full-color-picker">
    <div class="-header">
      <span class="wt2-text-n2">Preview Color</span>
      <wt-radio-text
        :value="displayCurType"
        :buttons="displayTypes"
        :full="true"
        @select="changeTypeManually"
      />
    </div>
    <transition name="wt2-sliding-down-fade">
      <div class="-gradient" v-if="isGradient">
        <gradient-slider
          :angles="gradientAngles"
          :angle="curData.angle"
          :start="curData.start"
          :end="curData.end"
          :selected="curData._selectedGradient"
          :slider-background="backgroundGradientReflection"
          @update-angle="updateAngle"
          @update-selected-color="updateGradientColor"
          @update-start-position="updateStartPosition"
          @update-end-position="updateEndPosition"
          @swap-colors="swapColors"
        />
      </div>
    </transition>
    <div class="-card" :style="[backgroundReflection]">
      <span :style="textColor">Text Here</span>
      <div class="-caption">
        <hex-input
          :hex="curColorHex"
          :is-valid="isValidHex"
          @update-hex="updateHex"
        />
        <rgb-inputs
          :rgb="toRgb"
          :rgb-to-hex="rgbToHex"
          @update-hex="updateHex"
        />
      </div>
    </div>
    <div class="hsl-sliders">
      <hue-slider :hsl="toHsl" @update-hsl="updateHsl" />
      <saturation-slider :hsl="toHsl" @update-hsl="updateHsl" />
      <lightness-slider :hsl="toHsl" @update-hsl="updateHsl" />
    </div>
  </div>
</template>

<script>
import coreMixin from '../mixins/core.vue';
import hexInput from '../parts/hex.vue';
import rgbInputs from '../parts/rgb.vue';
import hueSlider from '../parts/hue.vue';
import saturationSlider from '../parts/saturation.vue';
import lightnessSlider from '../parts/lightness.vue';
import gradientSlider from '../parts/gradient.vue';

export default {
  mixins: [coreMixin],

  computed: {
    textColor() {
      let color;
      if (this.curType === 'Gradient') {
        color = '#fff';
      } else {
        const tiny = tinycolor(this.curColorHex);
        const brightness = tiny.getBrightness();
        if (brightness > 130) {
          color = 'rgba(0,0,0,.3)';
        } else {
          color = '#fff';
        }
      }

      return {
        color,
      };
    },
  },

  components: {
    hexInput,
    rgbInputs,
    hueSlider,
    saturationSlider,
    lightnessSlider,
    gradientSlider,
  },
};
</script>
